<!-- TEMPLATE -->
<template>
  <div class="wrapper">
    <dean-dialog
            title="Nieuwe locatie"
            :small="true"
            :addClose="true"
            @close="close"
    >
      <slot name="load">

      </slot>
      <dean-select-form-row placeholder="Kies een context" id='addressContext' label='Soort adres'
                            :options='addressContextList' :value='currentAddressType'
                            @input='addressTypeFieldChanged' :required-field="true"
                            :warning="$v.data.addressContext.$error"
                            @focus="$v.data.addressContext.$touch()"></dean-select-form-row>
      <dean-form-row label="Postcode" type="string"
                      v-model="data.postalCode"
                      :warning="$v.data.postalCode.$error"
                      @focus="$v.data.postalCode.$touch()"
                      :requiredField="true"></dean-form-row>
      <dean-form-row label="Huisnummer" type="string"
                      v-model="data.houseNumber"
                      :warning="$v.data.houseNumber.$error"
                      @focus="$v.data.houseNumber.$touch()"
                      :requiredField="true"></dean-form-row>
      <dean-form-row label="Toevoeging huisnummer" type="string"
                      v-model="data.houseNumberExtension"
                      :requiredField="false"></dean-form-row>
      <dean-form-row label="Straat" type="string"
                      v-model="data.street"
                      :warning="$v.data.street.$error"
                      @focus="$v.data.street.$touch()"
                      :requiredField="true"></dean-form-row>
      <dean-form-row label="Plaats" type="string"
                      v-model="data.city"
                      :warning="$v.data.city.$error"
                      @focus="$v.data.city.$touch()"
                      :requiredField="true"></dean-form-row>
      <span slot="dean-dialog-button-group">
        <dean-button :danger="true" :dialog-button="true" @click.native="close()">Annuleren</dean-button>
        <dean-button :success="true" :dialog-button="true" @click.native="processAddress()">Check snelheid</dean-button>
      </span>
    </dean-dialog>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
  import Vue from 'vue';
  import {Component, Prop} from 'vue-property-decorator';
  import {
      deanDialog,
      saveIcon,
  } from '@deanone/dean-components';
  import deanButton from '@/components/deanComponents/deanButton.vue';
  import DeanNotification from '@/components/deanComponents/deanNotification.vue';
  import deanAlertDialog from '@/components/deanComponents/deanAlertDialog.vue';
  import deanFormRow from '@/components/deanComponents/deanFormRow.vue';
  import {deanDialogBus} from '@/main';
  import axios from 'axios';
  import {Validations} from 'vuelidate-property-decorators';
  import {required} from 'vuelidate/lib/validators';
  import {createNotification} from '@/mixins/validations';
  import {postalCode} from '@/mixins/validators';
  import DeanSelectFormRow from '@/components/deanComponents/deanSelectFormRow.vue';

  @Component({
      components: {
          DeanNotification,
          deanDialog,
          deanButton,
          deanAlertDialog,
          deanFormRow,
          saveIcon,
          DeanSelectFormRow,
      },
  })


  export default class AddAddressDialog extends Vue {
    @Prop() public payloadData!: {
      [key: string]: {
        [key: string]: string,
      };
    };

    @Validations()
    get validations() {
      return {
        data: {
          houseNumber: {required},
          houseNumberExtension: {},
          postalCode: {required, postalCode},
          street: {required},
          city: {required},
          addressContext: {required},
        },
      };
    }

    public newAddressId: string = '';
    public data: {
      personId: any
      addressContext: any
      houseNumber: any,
      houseNumberExtension: any,
      postalCode: any,
      street: any,
      city: any,
    } = {
      personId: this.payloadData.personId,
      addressContext: null,
      houseNumber: null,
      houseNumberExtension: null,
      postalCode: null,
      street: null,
      city: null,
    };

    get addressData(): {
      personId: any,
      addressContext: any
      houseNumber: any,
      houseNumberExtension: any,
      postalCode: any,
      street: any,
      city: any,
    } {
      return this.data;
    }

    get addressContextList() {
      return [
        {value: 'main', label: 'Bezoekadres'},
        {value: 'postal', label: 'Postadres'},
        {value: 'invoice', label: 'Factuuradres'},
        {value: 'product', label: 'Aansluitadres'},
        {value: 'delivery', label: 'Bezorgadres'},
      ];
    }

    get currentAddressType() {
      const addressContexts = this.addressContextList;
      const currentAddressType = this.addressData.addressContext;
      if (currentAddressType !== null) {
        const foundKey: any = Object.keys(addressContexts).find((key) =>
          // @ts-ignore-next-line
          addressContexts[key].value === currentAddressType);
        return foundKey != null ? addressContexts[foundKey] : null;
      }
      return null;
    }

    public addressTypeFieldChanged(field: any) {
      this.data.addressContext = field.value;
    }

    public close() {
      deanDialogBus.$emit('close');
    }

    public processAddress() {
      this.$v.$touch();

      if (! this.$v.$invalid) {
        const url = '/-/trade/api/customer.address.save';

        axios.post(url, this.addressData).then(
          (response: any) => {
            this.$toast({
                icon: saveIcon,
                text: 'Adres opgeslagen',
                theme: 'success',
            });
            this.newAddressId = response.data.id;
          },
          (error: any) => {
            this.$toast(this.$store.state.main.notification.messages.couldNotSendData);
          },
        ).finally(() => {
          deanDialogBus.$emit('RefreshAddresses', {
            addressId: this.newAddressId,
          });
          deanDialogBus.$emit('close');
        });
      } else {
        this.$toast(createNotification(this.$v));
      }
    }
  }
</script>

<!-- STYLE -->
<style lang="scss" scoped>
  // IMPORT
  @import '~@deanone/dean-components/src/scss/vars';

  :deep(.dean-button) {
    .dean-button-theme-grey {
      &:hover {
        background: white;
        color: var(color-dark-shade-4);
        cursor: default;
      }
    }
  }
</style>
